import PageLayout from './pages/pageLayout';

const AppUpdated = () => <PageLayout />;

export default AppUpdated;
